if (!customElements.get('moda-clubs-watch-sign')) {
  customElements.define('moda-clubs-watch-sign', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.root = this.closest('.mc-home');
      this.minuteClock = this.querySelector('.mc-minute-vector') ? this.querySelector('.mc-watch-drawing') : null;
      this.minuteClock?.pauseAnimations();
      this.minuteClock?.setCurrentTime(0);
      this.coordinated = Boolean(this.root?.querySelector('moda-hero-text-reveal'));
      this.waitingForHero = this.coordinated;
      this.manualPause = false;
      this.visible = false;
      this.pausedAnimations = new Set();
      this.pauseButton = this.querySelector('[data-sign-pause]');
      this.controls = this.querySelector('.mc-watch-controls');
      const signal = this.events.signal;
      const replay = event => {
        this.waitingForHero = false;
        this.manualPause = false;
        this.pausedAnimations.clear();
        const start = event?.detail?.startedAt ?? document.timeline.currentTime;
        this.minuteClock?.pauseAnimations();
        this.minuteClock?.setCurrentTime(Math.max(0, (document.timeline.currentTime - start) / 1000));
        this.getAnimations({ subtree: true }).forEach(animation => {
          animation.currentTime = 0;
          animation.play();
          animation.startTime = start;
        });
        this.updatePlayback();
      };
      this.querySelector('[data-sign-replay]').addEventListener('click', () => {
        if (this.coordinated) {
          this.root.dispatchEvent(new CustomEvent('mc-hero-motion-replay', { detail: { startedAt: document.timeline.currentTime } }));
        } else replay();
      }, { signal });
      this.pauseButton.addEventListener('click', () => {
        if (this.coordinated) {
          this.root.dispatchEvent(new CustomEvent('mc-hero-motion-pause', { detail: { paused: !this.manualPause } }));
        } else {
          this.manualPause = !this.manualPause;
          this.updatePlayback();
        }
      }, { signal });
      if (this.coordinated) {
        this.root.addEventListener('mc-hero-motion-replay', replay, { signal });
        this.root.addEventListener('mc-hero-motion-pause', event => {
          this.manualPause = event.detail.paused;
          this.updatePlayback();
        }, { signal });
      }
      this.reduced.addEventListener('change', () => this.configure(), { signal });
      document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal });
      if ('IntersectionObserver' in window) {
        const threshold = this.coordinated ? 0.01 : 0.15;
        this.visibility = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= threshold;
          this.updatePlayback();
        }, { threshold });
        this.visibility.observe(this.coordinated ? this.closest('.hero') : this);
      } else this.visible = true;
      this.configure();
    }

    configure() {
      const allowed = this.dataset.motion === 'true' && !this.reduced.matches && typeof this.getAnimations === 'function';
      this.classList.toggle('mc-watch-active', allowed);
      this.dataset.state = allowed ? 'ready' : 'static';
      this.controls.hidden = !allowed;
      this.pausedAnimations.clear();
      this.minuteClock?.pauseAnimations();
      this.minuteClock?.setCurrentTime(0);
      this.updatePlayback();
    }

    updatePlayback() {
      if (!this.events || this.dataset.state !== 'ready') return;
      const paused = this.waitingForHero || this.manualPause || !this.visible || document.hidden;
      const animations = this.getAnimations({ subtree: true });
      if (paused) {
        this.minuteClock?.pauseAnimations();
        animations.forEach(animation => {
          if (animation.playState === 'running' || animation.pending) {
            animation.pause();
            this.pausedAnimations.add(animation);
          }
        });
      } else {
        this.minuteClock?.unpauseAnimations();
        this.pausedAnimations.forEach(animation => {
          const end = animation.effect?.getComputedTiming().endTime ?? Infinity;
          if (animation.currentTime < end) animation.play();
        });
        this.pausedAnimations.clear();
      }
      this.dataset.running = String(!paused);
      this.dataset.paused = String(this.manualPause);
      if (this.minuteClock) {
        this.dataset.minuteTime = this.minuteClock.getCurrentTime().toFixed(3);
        this.dataset.minutePaused = String(this.minuteClock.animationsPaused());
      }
      this.pauseButton.textContent = this.manualPause ? this.dataset.resume : this.dataset.pause;
      this.pauseButton.setAttribute('aria-pressed', String(this.manualPause));
    }

    disconnectedCallback() {
      this.events?.abort();
      this.visibility?.disconnect();
      this.minuteClock?.pauseAnimations();
      if (typeof this.getAnimations === 'function') this.getAnimations({ subtree: true }).forEach(animation => animation.cancel());
      this.classList.remove('mc-watch-active');
      this.pausedAnimations?.clear();
      this.events = null;
    }
  });
}

